export const env = (name: string): string => {
  const nameWithoutPrefix = name.replace(/^REACT_APP_/, '');
  const value = window?._env_?.[name] ?? window?._env_?.[nameWithoutPrefix] ?? process?.env?.[name] ?? '';
  return value.replace(/\/$/, '');
};

export const getCdnUrl = (url: string | undefined | null): string => {
  if (!url || typeof url !== 'string') return url || '';
  if (url.includes('storage.googleapis.com') || url.includes('storage.cloud.google.com')) {
    const match = url.match(/^https?:\/\/storage\.(?:googleapis|cloud\.google)\.com\/[^/]+\/(.*)$/);
    if (match) {
      const filePath = match[1];
      const staticUrl = env('REACT_APP_STATIC_URL');
      const baseUrl = staticUrl.endsWith('/') ? staticUrl : `${staticUrl}/`;
      return `${baseUrl}${filePath}`;
    }
  }
  return url;
};
